/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function AppleLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00004 255.99998"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M218.51254,162.9332C205.936,193.65156,183.10562,216,164,216H92c-28,0-64-48-64-100A60.00062,60.00062,0,0,1,128.00185,71.27954l-.00164-.00185a60.0047,60.0047,0,0,1,87.16862,7.63587l-.00019.00015a48.01693,48.01693,0,0,0,3.33915,84.01754Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M218.51254,162.9332C205.936,193.65156,183.10562,216,164,216H92c-28,0-64-48-64-100A60.00062,60.00062,0,0,1,128.00185,71.27954l-.00164-.00185a60.0047,60.0047,0,0,1,87.16862,7.63587l-.00019.00015a48.01693,48.01693,0,0,0,3.33915,84.01754Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M143.53892,23.36749A31.931,31.931,0,0,1,168,12"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default AppleLogo;
